module.exports = __webpack_public_path__ + "static/img/popup_top_bg@2x.0d164b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/popup_top_bg@2x.png
// module id = ChOj
// module chunks = 8